module.exports = __webpack_public_path__ + "img/00021.56f58bb1.webp";